const getUrlImage = (url, setAppImage) => {
  const urlApi = url;
  let event = {
    target: { value: urlApi }
  };
  setAppImage(event);
};

export default getUrlImage;
